import { render } from "./TeamLibrary.vue?vue&type=template&id=8d4d89ec&scoped=true"
import script from "./TeamLibrary.vue?vue&type=script&lang=js"
export * from "./TeamLibrary.vue?vue&type=script&lang=js"

import "./TeamLibrary.vue?vue&type=style&index=0&id=8d4d89ec&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d4d89ec"]])

export default __exports__